import { makeStyles } from 'tss-react/mui';

import { dFlex, scrollBar } from '@assets/mixins';

const useStyles = makeStyles()((theme) => ({
  modal: {
    ...dFlex('center', 'flex-start'),
    flexDirection: 'column',
    gap: 24,
    height: '100%',
  },
  headerModal: {
    ...dFlex(),
    gap: 8,
  },
  closeBtn: {
    ...dFlex(),

    '& svg': {
      width: 24,
    },
  },
  children: {
    // Fill the space left by the header instead of claiming the modal's full
    // height — height:100% here pushed the total past the dialog and, with the
    // parent's justify-content:center, clipped the title off the top edge.
    flex: 1,
    minHeight: 0,
    width: '100%',
  },
  dialog: {
    height: 'calc(100% - 40px)',
    top: 'unset',

    '& .MuiDialog-paper': {
      background: theme.palette.custom.background.medium,
      padding: '16px 16px 40px 16px',
      borderRadius: '16px 16px 0px 0px',
      ...scrollBar,
    },

    '& .MuiModal-backdrop': {
      background: '#402C18B8',
    },
  },
}));

export default useStyles;
